'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '1eoyWgrdW3kDrXMTv5Jxi-tI593tkzZCiqRqcC0HG9co';